export const isDeviceAttachment = (myAppliance: string | null) => {
  if (!myAppliance) {
    return false;
  }
  return myAppliance.startsWith("NE-UBS5A") || myAppliance.startsWith("NE-SUBS5A");
}